import { render, staticRenderFns } from "./BasisCell.vue?vue&type=template&id=bb315806&scoped=true&"
import script from "./BasisCell.vue?vue&type=script&lang=js&"
export * from "./BasisCell.vue?vue&type=script&lang=js&"
import style0 from "./BasisCell.vue?vue&type=style&index=0&id=bb315806&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb315806",
  null
  
)

export default component.exports